module.exports = __webpack_public_path__ + "static/media/favicon.029a44d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/layouts/favicon.png
// module id = 1871
// module chunks = 0